import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgVideoIconSecondary(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M14.35 2H1.65C.74 2 0 2.74 0 3.65v8.64c0 .91.74 1.65 1.65 1.65h12.7c.91 0 1.65-.74 1.65-1.65V3.65C16 2.74 15.26 2 14.35 2Zm.15 10.29c0 .08-.07.15-.15.15H1.65c-.08 0-.15-.07-.15-.15V3.65c0-.08.07-.15.15-.15h12.7c.08 0 .15.07.15.15v8.64Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M6.64 4.53a.751.751 0 1 0-.77 1.29l3.61 2.15L7 9.45V7.98a.749.749 0 1 0-1.5 0v2.79a.752.752 0 0 0 .75.75c.13 0 .27-.04.38-.11l4.69-2.8c.23-.14.37-.38.37-.64a.74.74 0 0 0-.37-.64l-4.68-2.8Z",
    fill: "currentColor"
  }));
}

export { SvgVideoIconSecondary as default };
